import React, { useRef, useState, useEffect } from "react";
import styled from "styled-components";
import InputText from "../InputText/InputText";
import withSizes from "react-sizes";

const WithValidation = styled.div`
  width: 100%;
  min-width: 280px;
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
`;

const YoutubeIframe = styled.iframe`
  height: ${props => props.height}px;
  width: ${props => props.width}px;
`;

export default withSizes(({ width }) => {
  const componentWidth = width >= 950 ? 700 : width - 80;
  return {
    width: componentWidth,
    height: Math.floor((componentWidth * 9) / 16)
  };
})(({ videoLink, onChange, readonly, width, height }) => {
  const [link, setLink] = useState(videoLink || "");
  let videoParts = link.split("/");
  let id = videoParts[videoParts.length - 1];
  videoParts = id.split("=");
  id = videoParts[videoParts.length - 1];
  const ref = useRef();
  return (
    <WithValidation>
      {!readonly && (
        <InputText
          ref={ref}
          placeholder="e.g. https://youtu.be/yppvfp34z-o"
          value={link}
          onChange={e => {
            setLink(e.target.value);
          }}
          onBlur={() => {
            if (onChange) {
              onChange(link);
            }
          }}
          onEnter={() => {
            if (onChange) {
              onChange(link);
            }
          }}
        ></InputText>
      )}
      {id && (
        <YoutubeIframe
          width={width}
          height={height}
          src={`https://www.youtube-nocookie.com/embed/${id}`}
          frameborder="0"
          allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture"
          allowfullscreen
        ></YoutubeIframe>
      )}
    </WithValidation>
  );
});
